<script setup lang="ts">
import { ProductCarouselProps } from './ProductCarousel.vue'

const props = defineProps<ProductCarouselProps>()
const products = ref()
const i18n = useI18n()

const { getProducts } = useProducts()
const { isLoggedIn } = useUserStore()
const loading = ref(true)

onMounted(async () => {
  const fetchedProducts = await getProducts(props.skUs)
  if (fetchedProducts && !(fetchedProducts instanceof Error)) {
    products.value = fetchedProducts
      .filter((product) => product.inventory?.orderable)
      .map((product) => mapSfccProductDataToProductTile(product, i18n.locale.value))
    loading.value = false
  }
})
</script>

<template>
  <div class="cms-product-list">
    <LoadingSpinner v-if="loading" />
    <h5 v-if="title" class="cms-product-list__title heading-2">{{ title }}</h5>
    <p v-if="description" class="cms-product-list__description">{{ description }}</p>
    <div class="cms-product-list__container">
      <ProductTile
        v-for="(product, index) in products"
        :key="product.id"
        v-bind="product"
        :list-name="title"
        :index="index"
        :total-products="products.length"
        :open-in-new-tab="false"
        :action="supportingData?.home?.action?.value"
        :is-authenticated="isLoggedIn"
      />
    </div>
  </div>
</template>

<style lang="postcss">
.cms-product-list {
  .cms-product-list__title {
    margin-bottom: var(--space-50);
  }

  .cms-product-list__description {
    margin-bottom: 0;
  }

  .cms-product-list__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--space-50);
    margin-block: var(--space-70);
  }
}
</style>
